import Image from 'next/image'
import { useTranslation } from 'hooks/useTranslation'
import Trans from 'next-translate/Trans'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import {
  Badge,
  EnergyIllustration,
  HeroRoot,
  IllustrationContainer,
  Pattern,
  TextContainer,
} from './Hero.styles'

import * as heroIllustration from '../../../../../../../public/assets/raw-benefits/hero.webp'
import * as pattern from '../../../../../../../public/assets/raw-benefits/hero-pattern.webp'
import * as energyIllustration from '../../../../../../../public/assets/raw-benefits/hero-illustration-enery.svg'
import * as badge from '../../../../../../../public/assets/raw-benefits/badge-3-yellow.svg'
import { Link } from '../../../../../../components/Link'
import { Button } from '../../../../../../components/Button'

export const Hero = () => {
  const { t } = useTranslation()

  return (
    <HeroRoot>
      <IllustrationContainer>
        <Image src={heroIllustration} alt="" />
      </IllustrationContainer>
      <TextContainer>
        <Stack gap="3" direction="column">
          <Text as="h1" size="h1" weight="bold" color="tertiary-200">
            <Trans
              i18nKey="raw-benefits:title"
              components={{
                red: <Text size="h1" color="primary-500" weight="bold" />,
              }}
            />
          </Text>
          <Text size="headline" color="tertiary-200" weight="bold">
            {t('raw-benefits:subtitle')}
          </Text>
        </Stack>
        <Link href="/meal-plan" passHref>
          <Button as="a" className="cta">
            {t('raw-benefits:cta')}
          </Button>
        </Link>
      </TextContainer>
      <EnergyIllustration>
        <Image src={energyIllustration} />
      </EnergyIllustration>
      <Badge>
        <Image src={badge} />
      </Badge>
      <Pattern>
        <Image src={pattern} />
      </Pattern>
    </HeroRoot>
  )
}
